/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Unassigned_RowInputs */

const en_speakers_metrics_unassigned_row = /** @type {(inputs: Speakers_Metrics_Unassigned_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

const fr_speakers_metrics_unassigned_row = /** @type {(inputs: Speakers_Metrics_Unassigned_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

const de_speakers_metrics_unassigned_row = /** @type {(inputs: Speakers_Metrics_Unassigned_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

const it_speakers_metrics_unassigned_row = /** @type {(inputs: Speakers_Metrics_Unassigned_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

const ru_speakers_metrics_unassigned_row = /** @type {(inputs: Speakers_Metrics_Unassigned_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

const es_speakers_metrics_unassigned_row = /** @type {(inputs: Speakers_Metrics_Unassigned_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

const zh_cn2_speakers_metrics_unassigned_row = /** @type {(inputs: Speakers_Metrics_Unassigned_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

const ja_speakers_metrics_unassigned_row = /** @type {(inputs: Speakers_Metrics_Unassigned_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

const hi_speakers_metrics_unassigned_row = /** @type {(inputs: Speakers_Metrics_Unassigned_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

const pt_pt2_speakers_metrics_unassigned_row = /** @type {(inputs: Speakers_Metrics_Unassigned_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

/**
* | output |
* | --- |
* | "Unassigned" |
*
* @param {Speakers_Metrics_Unassigned_RowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_unassigned_row = /** @type {((inputs?: Speakers_Metrics_Unassigned_RowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Unassigned_RowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_metrics_unassigned_row(inputs)
	if (locale === "de") return de_speakers_metrics_unassigned_row(inputs)
	if (locale === "it") return it_speakers_metrics_unassigned_row(inputs)
	if (locale === "ru") return ru_speakers_metrics_unassigned_row(inputs)
	if (locale === "es") return es_speakers_metrics_unassigned_row(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_metrics_unassigned_row(inputs)
	if (locale === "ja") return ja_speakers_metrics_unassigned_row(inputs)
	if (locale === "hi") return hi_speakers_metrics_unassigned_row(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_metrics_unassigned_row(inputs)
	return en_speakers_metrics_unassigned_row(inputs)
});